import React from "react"
import propTypes from "prop-types"
import Loader from "react-loader-spinner"
import { connect } from "react-redux"
import {
  getParticipants,
  addParticipant,
  acceptInvite
} from "../../../../services/guardians"
import { validateForm } from "../../../../services/validation"
import "./styles.scss"

import Form, {
  Group,
  Input,
  TextArea,
  Select
} from "../../../../components/Form"
import Header from "../../../../components/Header"
import Notifications from "../../../../components/Notifications"
import Footer from "../../../../components/Footer"
import Card, { Title, Description } from "../../components/Card"
import Button from "../../../../components/Button"
import Repeater from "../../components/Repeater"
import Popup from "../../components/Popup"
import AlertPopup from "../../../../components/AlertPopup"

class MyParticipants extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        fullName: {
          label: "Full Name",
          placeholder: "Participants name",
          name: "fullName",
          type: "text",
          value: "",
          required: true
        },
        relationship: {
          label: "Relationship",
          placeholder: "What Is Your Relationship",
          name: "relationship",
          value: "",
          options: [
            {
              value: "S",
              label: "Spouse"
            },
            {
              value: "P",
              label: "Parent"
            },
            {
              value: "C",
              label: "Child"
            },
            {
              value: "E",
              label: "Extended Family"
            },
            {
              value: "F",
              label: "Friend"
            }
          ],
          required: true
        },
        email: {
          label: "Email",
          placeholder: "Enter Their Email",
          name: "email",
          type: "email",
          value: "",
          required: true
        },
        requestMessage: {
          label: "Request message ",
          placeholder: "",
          name: "requestMessage",
          type: "textarea",
          value: "",
          required: true
        }
      },
      popupFormIsHidden: true,
      popupAlertIsHidden: true,
      acceptInviteLoading: false,
      isSubmitted: false,
      errorMessage: "",
      answersLoading: false
    }
  }

  componentDidMount() {
    const {
      store: { user },
      onGetParticipants
    } = this.props

    onGetParticipants(user.token)
  }

  openFormPopup = e => {
    if (e) e.preventDefault()

    this.setState({ popupFormIsHidden: false })
  }

  closeFormPopup = () => {
    this.setState({ popupFormIsHidden: true })
  }

  closeAlertPopup = () => {
    this.setState({ popupAlertIsHidden: true })
  }

  addItem = () => {
    const { form } = this.state
    const {
      store: { user },
      onAddParticipant
    } = this.props

    this.setState({ errorMessage: "" })

    const res = validateForm(form)

    if (Object.keys(res).length === 0 && res.constructor === Object) {
      const participant = {
        full_name: form.fullName.value,
        relationship: form.relationship.value,
        email: form.email.value,
        message: form.requestMessage.value
      }

      onAddParticipant(user.token, participant).then(
        () => {
          this.setState({
            popupFormIsHidden: true,
            popupAlertIsHidden: false
          })
        },
        message => {
          if (message) {
            const newForm = {}
            let errorMessage = ""

            Object.keys(message).map(key => {
              if (key === "full_name") {
                newForm.fullName = {
                  ...form.fullName,
                  message: message.full_name[0]
                }
              } else if (key === "relationship") {
                newForm.relationship = {
                  ...form.relationship,
                  message: message.relationship[0]
                }
              } else if (key === "email") {
                newForm.email = {
                  ...form.email,
                  message: message.email[0]
                }
              } else if (key === "message") {
                newForm.requestMessage = {
                  ...form.requestMessage,
                  message: message.message[0]
                }
              } else if (key === "error") {
                errorMessage = message.error
              }

              return null
            })

            this.setState({
              isSubmitted: true,
              errorMessage,
              form: {
                ...form,
                ...newForm
              }
            })
          }
        }
      )
    } else {
      this.setState({
        isSubmitted: true,
        form: {
          ...form,
          ...res
        }
      })
    }
  }

  onChange = (name, field, value) => {
    const { form } = this.state

    this.setState({
      form: {
        ...form,
        [name]: {
          ...form[name],
          message: "",
          [field]: value
        }
      }
    })
  }

  handleAcceptInvite = id => {
    const {
      store: { user },
      onGetParticipants
    } = this.props

    this.setState({ acceptInviteLoading: true })

    acceptInvite(user.token, id).then(() => {
      onGetParticipants(user.token).then(() => {
        this.setState({ acceptInviteLoading: false })
      })
    })
  }

  handleFetchPlansAnswers = id => {
    const { history } = this.props

    if (id) {
      history.push({
        pathname: "/pre-plan/about-me",
        state: { planId: id }
      })
    }
  }

  render() {
    const {
      notifications,
      store: { participants, loading }
    } = this.props

    const {
      popupFormIsHidden,
      popupAlertIsHidden,
      form,
      isSubmitted,
      errorMessage,
      acceptInviteLoading,
      answersLoading
    } = this.state

    return (
      <div className="main-container main-container--light my-participants">
        <Header theme="dark" />

        <div className="content">
          <div
            className={`content_section_header ${notifications &&
              "content_section_header--dark"}`}
          >
            <div className="container">
              <div className="row">
                <div className="col-md-10 offset-md-1">
                  <h1 className="content_section_title">My participants</h1>
                </div>
              </div>
            </div>

            <Notifications />
          </div>

          <div className="container">
            <div className="row">
              <div className="col-xl-8 offset-xl-2">
                {loading || answersLoading ? (
                  <Loader
                    type="TailSpin"
                    color="#0c4632"
                    height={80}
                    width={80}
                    className="loader"
                  />
                ) : (
                  <>
                    {participants.map((participant, index) => {
                      const key = `participant-${index}`
                      return (
                        <div key={key}>
                          {participant.participant && (
                            <Card
                              className={
                                participant.status.includes("accepted")
                                  ? "card--yellow-light"
                                  : "card--gray"
                              }
                            >
                              <Title>
                                {participant.participant.first_name}{" "}
                                {participant.participant.last_name}
                              </Title>
                              <Description>
                                Support your NDIS participant by inspecting and
                                suggesting improvements about how improve their
                                NDIS support pre-plan
                              </Description>
                              {(() => {
                                switch (participant.status) {
                                  case "accepted":
                                    return (
                                      <Button
                                        button={{ type: "button" }}
                                        onClick={() =>
                                          this.handleFetchPlansAnswers(
                                            participant.participant.plan.id
                                          )
                                        }
                                        className="btn--secondary-light btn--width-lg btn--height-md btn--font-size-sm"
                                      >
                                        Inspect{" "}
                                        {participant.participant.first_name}
                                        &apos;s pre-plan
                                      </Button>
                                    )
                                  case "pending - awaiting guardian":
                                    return (
                                      <Button
                                        button={{
                                          type: "button",
                                          disabled: acceptInviteLoading
                                        }}
                                        onClick={() =>
                                          this.handleAcceptInvite(
                                            participant.participant.id
                                          )
                                        }
                                        className="btn--secondary-light btn--width-lg btn--height-md btn--font-size-sm"
                                      >
                                        Accept invite
                                      </Button>
                                    )
                                  case "pending - awaiting participant":
                                    return (
                                      <Button
                                        button={{
                                          type: "button",
                                          disabled: true
                                        }}
                                        className="btn--secondary-light btn--width-lg btn--height-md btn--font-size-sm"
                                      >
                                        Request pending
                                      </Button>
                                    )
                                  default:
                                    return null
                                }
                              })()}
                            </Card>
                          )}
                        </div>
                      )
                    })}

                    <Repeater
                      text="Request access to a participants plan"
                      onClick={this.openFormPopup}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <Footer />

        <Popup onClose={this.closeFormPopup} isHidden={popupFormIsHidden}>
          <Form
            formRef={el => {
              this.form = el
            }}
          >
            {errorMessage && (
              <div className="form_message form_message--global">
                {errorMessage}
              </div>
            )}

            <Group>
              <Input
                onChange={this.onChange}
                isSubmitted={isSubmitted}
                field={form.fullName}
              />
            </Group>

            <Group>
              <Select
                onChange={this.onChange}
                isSubmitted={isSubmitted}
                field={form.relationship}
                className="form_select--bordered"
              />
            </Group>

            <Group>
              <Input
                onChange={this.onChange}
                isSubmitted={isSubmitted}
                field={form.email}
              />
            </Group>

            <Group>
              <TextArea
                onChange={this.onChange}
                isSubmitted={isSubmitted}
                field={form.requestMessage}
              />
            </Group>

            <Group className="form_btn-group form_group--padding-top-lg">
              <Button
                button={{ type: "button", disabled: loading }}
                onClick={this.closeFormPopup}
                className="btn--empty-secondary-light btn--width-md btn--height-sm btn--font-size-md"
              >
                Back
              </Button>
              <Button
                button={{ type: "button", disabled: loading }}
                onClick={this.addItem}
                className="btn--secondary-light btn--width-md btn--height-sm btn--font-size-md"
              >
                Request participant
              </Button>
            </Group>
          </Form>
        </Popup>

        <AlertPopup
          onClose={this.closeAlertPopup}
          isHidden={popupAlertIsHidden}
          title="Participant request sent"
          description="Your request has been sent to the participant’s email inbox. Once they accept you can inspect and make suggestions to improve their pre-plan."
          type="success"
        />
      </div>
    )
  }
}

MyParticipants.propTypes = {
  onGetParticipants: propTypes.func.isRequired,
  onAddParticipant: propTypes.func.isRequired,
  notifications: propTypes.bool,
  history: propTypes.shape({
    push: propTypes.func
  }).isRequired,
  store: propTypes.shape({
    user: propTypes.shape({
      token: propTypes.string
    }),
    participants: propTypes.arrayOf(propTypes.shape({})),
    loading: propTypes.bool
  }).isRequired
}

MyParticipants.defaultProps = {
  notifications: false
}

const mapStateToProps = ({ AuthenticationReducer, GuardiansReducer }) => ({
  store: {
    user: AuthenticationReducer.user,
    participants: GuardiansReducer.participants,
    loading: GuardiansReducer.loading
  }
})

const mapDispatchToProps = dispatch => ({
  onGetParticipants: token => dispatch(getParticipants(token)),
  onAddParticipant: (token, participant) =>
    dispatch(addParticipant(token, participant))
})

export default connect(mapStateToProps, mapDispatchToProps)(MyParticipants)
